"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextInjectorMW = void 0;
const ContextInjectorMW = async (ctx, next) => {
    ctx.arguments.push(ctx);
    await next();
};
exports.ContextInjectorMW = ContextInjectorMW;
//# sourceMappingURL=contextInjector.js.map